/**
 * DevExtreme (esm/__internal/ui/text_box/m_text_editor.js)
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
import registerComponent from "../../../core/component_registrator";
import TextEditorMask from "./m_text_editor.mask";
registerComponent("dxTextEditor", TextEditorMask);
export default TextEditorMask;